import type React from 'react';
import { createContext, useContext } from 'react';

interface BlobImageConfigContextValue {
  readonly shouldForceBlobImages: boolean;
}

const defaultBlobImageConfig: BlobImageConfigContextValue = {
  shouldForceBlobImages: false,
};

export const BlobImageConfigContext: React.Context<BlobImageConfigContextValue> = createContext(defaultBlobImageConfig);

export const useBlobImageConfig = (): BlobImageConfigContextValue => useContext(BlobImageConfigContext);
